export enum AskAiStage {
  Guardrail = 'guardrail',
  Planning = 'planning',
  Searching = 'searching',
  Summarizing = 'summarizing',
}

export enum MessageRole {
  User = 'user',
  Assistant = 'assistant',
}

export enum MessageStatus {
  Fetching = 'fetching',
  Streaming = 'streaming',
  Completed = 'completed',
  Error = 'error',
}

export enum TurnStatus {
  Cancelled = 'cancelled',
  Failed = 'failed',
}

export type AskAiProduct = 'abs' | 'corp';

export interface IAskAiChatMessage {
  id: string,
  role: MessageRole,
  content: string,
  createdAt: string,
  status?: MessageStatus,
  stage?: AskAiStage,
  stageLabel?: string,
  progress?: number,
  errorMessage?: string,
  turnStatus?: TurnStatus,
}

export interface IAskAiChatSummary {
  id: string,
  title: string,
  createdAt: string,
  updatedAt: string,
}

export interface IAskAiChatHistoryMessage {
  id: string,
  role: MessageRole,
  content: string,
  createdAt: string,
  metadata: unknown,
}

export interface IAskAiChatListResult {
  items: IAskAiChatSummary[],
  page: number,
  perPage: number,
  total: number,
}

export interface IAskAiChatMessagesResult {
  items: IAskAiChatHistoryMessage[],
  nextBefore: string | null,
  hasMore: boolean,
}

export interface IAskAiExportResult {
  filename: string,
  mimeType: string,
  content: string,
}

interface IAskAiEventBase {
  chatId: string,
  messageId: string,
}

export interface IAskAiProcessingPayload {
  chatId: string,
  messageId?: string,
  stage: AskAiStage,
  label: string,
  progress?: number,
}

export interface IAskAiAnswerPayload extends IAskAiEventBase {
  content: string,
  seq: number,
}

export interface IAskAiDonePayload {
  chatId?: string,
}

export interface IAskAiErrorPayload {
  chatId?: string,
  messageId?: string,
  message: string,
}

export interface IAskAiCancelledPayload {
  chatId: string,
  cancelled: boolean,
}
